/**
 * 本地存储公共类
 * @author lee
 */
const key='token';
class storage {
  constructor() {
    if(!localStorage) {
    }else {
      this._storage=localStorage;
    }
  }
  /**
   * 设置本地缓存
   * @param key 键
   * @param value 值
   *  @param expire 有效期 { expireDate过期时间 秒,storageTime存储时间}
   */
  set(key, value,expire){
    if(expire>0){
      value={...value,...{expire:{expireDate:expire||0,storageTime:new Date().getTime()/1000}}};
    }
    this._storage&&this._storage.setItem(key, JSON.stringify(value))
  }
  // getItem(key: string): string | null;
  /**
   * 获取本地缓存
   * @param key 键
   */
  get(key){
    let _cache=JSON.parse(this._storage.getItem(key));
    let item={};
    switch (this.isExpire(_cache)) {
      case "null":
        item=null;
        break;
      case "expired":
        item=null;
        break;
      case "notExpired":
        item=this._storage&&_cache;
        break;
      case "notSet":
        item=this._storage&&_cache;
        break;
    }
    return item;
  }
  /**
   * 判断是否过期
   * @param _cache
   * return 'expired'|'notExpired'|'notSet'|'null' 已过期 未过期 未设置 无数据
   */
  isExpire(_cache){
    if(!_cache){
      return 'null';
    }
    if(!_cache.expire){
      return 'notSet';
    }
    if(_cache.expire.expireDate>0){
      let storedTime=new Date().getTime()/1000-_cache.expire.storageTime;//计算已存储时间
      if(storedTime>=_cache.expire.expireDate){
        this._storage.removeItem(key);
        return 'expired';
      }
      return 'notExpired';
    }
  }
  // removeItem(key: string): void;

  /**
   * 清除对应键本地缓存
   * @param key
   */
  remove(key){
    this._storage&&this._storage.removeItem(key);
  }

  /**
   *获取token
   *
   * @memberof Storage
   */
  get token(){
    return this.get(key)&&(this.get(key).token||null);
  }

  /**
   *设置token
   * @memberof Storage
   */
  set token(token){
    if(token){
      let _user=this.get(key);
      _user.token=token;
      this.set(key,_user)
    }

  }
  /**
   *获取已登录用户信息
   *
   * @memberof Storage
   */
  get user(){
    if(this.get(key)){
      return this.get(key).user||{}
    }
    return null;
  }
  /**
   *设置已登录与用户信息
   *
   * @memberof Storage
   */
  set user(user){
    let _token=this.get(key);
    _token.user=user;
    this.set(key,_token);
  }
  /**
   * 清除所有缓存
   */
  clear(){
    this._storage&&this._storage.clear();
  }
  /**
   * 获取localStorage的剩余容量
   */
  getRm(){
    let size = 0;
    for(let item in this._storage) {
      if(this._storage.hasOwnProperty(item)) {
        size += this._storage.getItem(item).length;
      }
    }
    return size/ 1024 / 1024<1?(size / 1024).toFixed(2)+'KB':(size / 1024 / 1024).toFixed(2)+'M';
  }

}
export {storage};



// WEBPACK FOOTER //
// ./src/util/storage.js